
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import AuthMixin from '@/mixins/AuthMixin.vue'
import LabeledValue from '@/components/LabeledValue.vue'
import { OrderEntry } from '@/firestore'
import IconsMixin from '@/mixins/IconsMixin.vue'

@Component({
  components: {LabeledValue}
})
export default class OrderListItem extends Mixins(AuthMixin, IconsMixin) {
  @Prop({type: Object, required: true})
  public entry!: OrderEntry

  @Prop({type: String, default: 'None'})
  public reminder!: string

  @Emit()
  public selected(entry: OrderEntry) {
  }

  public isReceivedQuantityDifferent(entry: OrderEntry) {
    if (
        entry.receivedQuantity !== undefined
        && entry.receivedQuantity.toString().length
    ) {
      if (entry.receivedQuantityType && entry.receivedQuantityType !== entry.quantityType) {
        return true
      }

      const q = parseInt(entry.quantity.toString(), 10)
      const rq = parseInt(entry.receivedQuantity.toString(), 10)
      if (entry.additionalQuantity) {
        const aq = parseInt(entry.additionalQuantity.toString(), 10)
        return rq !== q + aq
      }
      return rq !== q
    }

    return false
  }

  get color() {
    if (this.entry.isRejected) {
      return 'error--text'
    } else if (this.entry.isComplete) {
      if (this.isReceivedQuantityDifferent(this.entry)) {
        return 'warning--text'
      } else {
        return 'success--text'
      }
    }
    return ''
  }
}
